import { Block, Typography } from '@xprog/prensa';
import React, { useEffect } from 'react';

const StoriesPopComponent = () => {
  useEffect(() => {
    const msfb = document.querySelector("#msfb");
    if (msfb) {
      msfb.innerHTML = `
        <div id="mss6" class="mpsa">
          <div class="msmd">
            <p class="msps"></p>
            <span>
              <p class="msst"></p>
              <p class="msso"></p>
            </span>
          </div>
          <div class="msmd">
            <p class="msps"></p>
            <span>
              <p class="msst"></p>
              <p class="msso"></p>
            </span>
          </div>
          <div class="msmd">
            <p class="msps"></p>
            <span>
              <p class="msst"></p>
              <p class="msso"></p>
            </span>
          </div>
          <div class="msmd">
            <p class="msps"></p>
            <span>
              <p class="msst"></p>
              <p class="msso"></p>
            </span>
          </div>
          <div class="msmd">
            <p class="msps"></p>
            <span>
              <p class="msst"></p>
              <p class="msso"></p>
            </span>
          </div>
        </div>
      `;
    }

    // Carrega os scripts de forma síncrona para garantir a execução correta
    const ampStoryScript = document.createElement('script');
    ampStoryScript.src = 'https://cdn.ampproject.org/amp-story-player-v0.js';
    ampStoryScript.onload = () => {
      const makeStoriesScript = document.createElement('script');
      makeStoriesScript.src = 'https://js.makestories.io/player/StoryPlayer.js';
      makeStoriesScript.onload = () => {
        // Inicializa o player após o carregamento do script
        if (window.msPlayer) {
          window.msPlayer({
            root: "#ms-story-player55ba295e7186",
            widgetId: "0a60ff20-b1cf-400c-9a9a-55ba295e7186",
            openButtonText: "Abrir"
          });
        }
      };
      document.body.appendChild(makeStoriesScript);
    };

    document.body.appendChild(ampStoryScript);

    // Cleanup dos scripts ao desmontar o componente
    return () => {
      document.body.removeChild(ampStoryScript);
    };
  }, []);

  return (
    <Block
      css={{ align: ['column', 'left', 'top'], width: 'auto', border: '1px solid #E3F1FC', borderRadius: '5px', padding: '0 $2', mb: '$4'}}
    >
      <Typography
        css={{
          color: '#000',
          fontFamily: '$primary',
          fontSize: '18px',
          lineHeight: '25px',
          fontWeight: 500,
          ml: '$1',
          mb: '0px'
        }}>
        Stories
      </Typography>
      <div>
        <div id="ms-story-player55ba295e7186">
          <style>{`
          #mss6 * {
            box-sizing: border-box;
            margin: 0;
          }
          .mpsa {
            scroll-behavior: smooth;
            width: 100%;
            height: 100%;
            padding: 15px 0;
          }
          #mss6 {
            margin: 0 auto;
            padding: 0 10px;
            max-width: 650px;
          }
          .mpsa::-webkit-scrollbar {
            height: 0;
            width: 0;
          }
          @keyframes shimmer {
            0% {
              left: -100px;
            }
            100% {
              left: 100px;
            }
          }
          #mss6 .msmd {
            width: 100%;
            display: flex;
            margin: 0 auto 20px;
            padding: 15px;
            border: 1px solid #194392;
            border-radius: 5px;
            max-width: 700px;
            background: #fff;
            color: #194392;
          }
          #mss6 .msso,
          #mss6 .msst {
            width: 25%;
            padding: 0 20px;
            margin-right: auto;
            height: 20px;
            position: relative;
            overflow: hidden;
            background: #e6e6e6;
            border-radius: 5px;
          }
          #mss6 .msso {
            height: 35px;
            width: 20%;
            margin-top: 10px;
          }
          #mss6 span {
            flex: 1;
            text-align: left;
          }
          #mss6 .msps {
            min-height: 120px;
            width: 100px;
            min-width: 100px;
            height: 100%;
            border-radius: 4px;
            object-fit: cover;
            margin-right: 15px;
            position: relative;
            overflow: hidden;
            background: #e6e6e6;
          }
          #mss6 .msps::after,
          #mss6 .msso::after,
          #mss6 .msst::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100px;
            width: 100px;
            background: linear-gradient(to right, #e6e6e6, rgba(255, 255, 255, 0.5), #e6e6e6);
            overflow: hidden;
            animation: shimmer 1.5s ease infinite;
          }
        `}</style>
          <div id="msfb"></div>
        </div>
        <link href="https://cdn.ampproject.org/amp-story-player-v0.css" rel="stylesheet" type="text/css" />
      </div>
    </Block>
  );
};

export default StoriesPopComponent;
